import script from "./BooksBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./BooksBlock.vue?vue&type=script&setup=true&lang=ts"

import "./BooksBlock.vue?vue&type=style&index=0&id=01a41f22&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a41f22"]])

export default __exports__